export default __webpack_public_path__ + "static/media/6.65690014.jpg";